export const buttonWrapper = {
  display: "flex",
  justifyContent: "flex-end",
};
